export default __webpack_public_path__ + "static/favicon-af222058a2afb454000ab39bcbcbc0e3.ico";